// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"MobileOnlyContent_mobileOnly__2DPBa"};